import React from 'react'

const ColorsContext = React.createContext({})
export const ColorsProvider = ColorsContext.Provider
export default ColorsContext
